module.exports = __webpack_public_path__ + "static/googleStoreImage.7a60f99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/googleStoreImage.png
// module id = 46
// module chunks = 11123261523102 35783957827783 114276838955818